export default {
  Esc: 'Đóng cửa sổ (ESC)',
  Add: 'Thêm (Ctrl + 1)',
  Edit: 'Sửa (Ctrl + E)',
  Delete: 'Xóa (Ctrl + D)',
  Save: 'Lưu (Ctrl + S)',
  Refresh: 'Nạp (Ctrl + R)',
  Cancel: 'Hủy (Ctrl + H)',
  Quit: 'Đóng (Ctrl + Q)',
  Help: 'Trợ giúp (F1)',
  Sort: 'Sắp xếp (Ctrl + /)',
  ShowHideColumn: 'Ẩn hiện cột (Ctrl + *)',
  InsertRowGrid: 'Thêm dòng (Ctrl + Insert)',
  DeleteRowGrid: 'Xóa dòng (Ctrl + Delete)',
  Duplicate: 'Nhân bản (Ctrl + Shift + C)',
  TabNew: 'Mở trên tab mới',
  Back: 'Quay lại',
  ShowSettingLayout: 'Ẩn hiện cột (Ctrl + *)',
  GetDefault:'Lấy lại mặc định',
  InsertApprove: 'Thêm mới (Ctrl + Insert)',
  MergeApprove: 'Gộp nội dung (Ctrl + G)',
  RefuseApprove: 'Từ chối (Ctrl + Delete)',
  Accept: 'Đồng ý (Ctrl + S)',
};
